export default __webpack_public_path__ + "static/media/front.59dd19f2.png";